import { createAPIAdapters } from "@mirage/service-conversation/service/conversationsSync/apiAdapters";
import { createConversationsDataSync } from "@mirage/service-conversation/service/conversationsSync/dataSync";
import { createConversationsMetadataSync } from "@mirage/service-conversation/service/conversationsSync/metadataSync";
import { createStorageAdapter } from "@mirage/service-conversation/service/conversationsSync/storageAdapters";

import type { KVStorageShape } from "@mirage/service-conversation/service/conversationsSync/storageAdapters";
import type {
  ConversationsSyncInterface,
  DataAPI,
  DataStorage,
} from "@mirage/service-conversation/service/conversationsSync/types";

import type { GuaranteedKVStorage } from "@mirage/storage";

export function createConversationsSync(
  storage: DataStorage,
  api: DataAPI,
): ConversationsSyncInterface {
  const metadataSync = createConversationsMetadataSync(api);
  const dataSync = createConversationsDataSync(storage, api, metadataSync);
  return {
    ...metadataSync,
    ...dataSync,
  };
}

export function createConversationsSyncWithAdapters(
  storage: GuaranteedKVStorage<KVStorageShape>,
): ConversationsSyncInterface {
  const storageAdapter = createStorageAdapter(storage);
  const apiAdapter = createAPIAdapters();
  return createConversationsSync(storageAdapter, apiAdapter);
}
